// extracted by mini-css-extract-plugin
module.exports = {"checkboxesContainer":"CreateEditClinics_checkboxesContainer__3X_xb","emails":"CreateEditClinics_emails__2hX5T","emailTagLabel":"CreateEditClinics_emailTagLabel__3wVN-"};